ACC.fileupload = {
  dragdropFunction: function() {
    $('.ph-common-file-upload,.ph-drop-section').on('dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
      ACC.fileupload.hideElement($('.ph-upload-section,.ph-uploading-section'), true);
      ACC.fileupload.showElement($('.ph-drop-section'), true);
    }).on('dragleave', function(e) {
      e.preventDefault();
      e.stopPropagation();
    }).on('drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      ACC.fileupload.showElement($('.ph-uploading-section'), true);
      ACC.fileupload.hideElement($('.ph-upload-section'), true);

      var boxFile = document.querySelector('input[type=\'file\']'),
          fileItem = e.originalEvent.dataTransfer.files,
          itemName = e.originalEvent.dataTransfer.files[0].name;

      boxFile.files = fileItem;
      ACC.fileupload.getFileChange(boxFile, itemName);
    });
  },
  bindAll: function() {
    this.fileUploadClick();

    $('.ph-remove-upload').on('click', function() {
      var removeUrl = $(this).attr('data-removeUrl');

      if (removeUrl === '') {
        ACC.fileupload.resetDiv();
      } else {
        var obj = {},
            resetMsg = $('.ph-file-name').attr('data-default'),
            parentForm = document.getElementById($('.ph-file-input').attr('data-parentForm'));

        obj.formData = new FormData(parentForm);
        obj.path = removeUrl;
        obj.fId = '.ph-file-input';
        obj.resetMsg = resetMsg;
        ACC.fileupload.removeFilebutton(obj);
      }
    });

    $('.ph-retry-upload').on('click', function() {
      ACC.fileupload.resetDiv();
    });
  },
  getFileChange: function(e, fileItem) {
    var file = '',
        obj = {},
        resetMsg = $('.ph-file-name').attr('data-default'),
        parentForm = document.getElementById($('.ph-file-input').attr('data-parentForm'));

    obj.formData = new FormData(parentForm);
    obj.path = $('.ph-file-input').attr('data-uploadUrl');
    obj.fId = '.ph-file-input';
    obj.resetMsg = resetMsg;

    if (fileItem && fileItem.length > 0) {
      obj.formData.append('getSpFile', fileItem);
      file = fileItem;
    } else {
      file = e.files[0].name;
    }

    $('.ph-file-name').html(file);
    ACC.fileupload.uplodDocButton(obj, e);
  },
  resetDiv: function() {
    ACC.fileupload.hideElement($('.ph-drop-section,.ph-uploading-section'), true);
    ACC.fileupload.showElement($('.ph-upload-section'), true);
    $('.ph-file-name').html($('.ph-file-name').attr('data-default'));
    $('.ph-file-input').val('');
  },
  showError: function() {
    var errorMsg = $('.ph-status-message').attr('data-errorMsg');

    $('.ph-status-message').html(errorMsg);
    ACC.fileupload.showElement($('.ph-status-message,.ph-retry-upload'));
    ACC.fileupload.hideElement($('.ph-progress-status,.ph-cancel-upload,.ph-progress,.ph-remove-upload'));
  },
  showElement: function(element, isFlex) {
    if (isFlex) {
      $(element).removeClass('ph-d-none').addClass('ph-d-flex');
    } else {
      $(element).removeClass('ph-d-none');
    }
  },
  hideElement: function(element, isFlex) {
    if (isFlex) {
      $(element).removeClass('ph-d-flex').addClass('ph-d-none');
    } else {
      $(element).addClass('ph-d-none');
    }
  },
  uplodDocButton: function(obj, event) {
    ACC.fileupload.showElement($('.ph-uploading-section'), true);
    ACC.fileupload.hideElement($('.ph-upload-section'), true);
    ACC.fileupload.hideElement($('.ph-status-message,.ph-remove-upload'));
    ACC.fileupload.showElement($('.ph-progress-status,.ph-cancel-upload,.ph-progress'));

    if ((/(\.pdf|\.png|\.gif|\.jpg|\.jpeg)$/i).test($('.ph-file-name').html())) {
      var fileSize = event.files[0].size,
          fileSizeInMb = Number(parseFloat(fileSize / 1024 / 1000).toFixed(2));

      if (fileSizeInMb <= 10.00) {
        var filexhr = $.ajax({
          xhr: function() {
            var xhr = new window.XMLHttpRequest();

            xhr.upload.addEventListener('progress', function(e) {
              if (e.lengthComputable) {
                var percent = Math.round((e.loaded / e.total) * 100);

                $('.ph-progress-bar').attr('aria-valuenow', percent).css('width', percent + '%');
                $('.ph-progress-percentage').text(percent + '%');
              }
            });

            return xhr;
          },
          url: obj.path,
          type: 'post',
          data: obj.formData,
          contentType: false,
          processData: false,
          enctype: 'multipart/form-data',
          success: function() {
            var successMsg = $('.ph-status-message').attr('data-successMsg');

            $('.ph-status-message').html(successMsg);
            ACC.fileupload.showElement($('.ph-status-message,.ph-remove-upload'));
            ACC.fileupload.hideElement($('.ph-drop-section,.ph-progress-status,.ph-cancel-upload,.ph-progress,.ph-retry-upload'), true);
          },
          error: function() {
            ACC.fileupload.showError();
          }
        });

        $('.ph-cancel-upload').on('click', function() {
          filexhr.abort();
          ACC.fileupload.hideElement($('.ph-drop-section,.ph-uploading-section'), true);
          ACC.fileupload.showElement($('.ph-upload-section'), true);
        });
      } else {
        $(obj.fId).val('');
        $('.ph-status-message').html($('.ph-status-message').attr('data-sizeError'));
        ACC.fileupload.showElement($('.ph-status-message, .ph-progress, .ph-retry-upload'));
        ACC.fileupload.hideElement($('.ph-drop-section,.ph-progress-status,.ph-cancel-upload,.ph-progress,.ph-remove-upload'), true);
      }
    } else {
      $(obj.fId).val('');
      $(obj.fId).focus();
      $('.ph-status-message').html($('.ph-status-message').attr('data-wrongFile'));
      ACC.fileupload.showElement($('.ph-status-message,.ph-retry-upload'));
      ACC.fileupload.hideElement($('.ph-drop-section,.ph-progress-status,.ph-cancel-upload,.ph-progress,.ph-remove-upload'), true);
    }
  },
  fileUploadClick: function() {
    $('.ph-file-choose-btn').on('click', function() {
      var $fileInput = $(this).closest('.ph-upload-section').find('.ph-file-input');

      $fileInput.trigger('click');
    });
  },
  removeFilebutton: function(obj) {
    $.ajax({
      url: obj.path,
      type: 'post',
      data: obj.formData,
      contentType: false,
      processData: false,
      enctype: 'multipart/form-data',
      success: function() {
        ACC.fileupload.resetDiv();
      }
    });
  }
};

$(document).ready(function() {
  ACC.fileupload.bindAll();

  if ($('.ph-common-file-upload').length > 0 && $('.ph-page-register').length === 0) {
    ACC.fileupload.dragdropFunction();
  }
});
$(window).on('load', function() {
  var fileName = $('.ph-file-input').attr('data-imageName');

  if (fileName !== '') {
    $('.ph-file-name').html(fileName);
  }
});
